import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Mail, Phone } from 'lucide-react';
import Reveal from '@/components/site/Reveal';
import { SITE } from '@/lib/site';

export default function Founder() {
  return (
    <section data-testid="founder-section" className="py-20 md:py-28 bg-white">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12 md:items-center">
          <div className="md:col-span-5">
            <Reveal>
              <div className="relative overflow-hidden rounded-2xl bg-slate-100">
                <img
                  src="/team/founder-md.jpg"
                  alt="Bhavani Prasad Dornala, Founder & Managing Director of Cespedis"
                  className="h-[480px] w-full object-cover object-top md:h-[560px]"
                />
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#144726] via-[#144726]/60 to-transparent p-6">
                  <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#C6A35B]">Founder & Managing Director</p>
                  <p className="mt-1 font-display text-2xl font-semibold text-white">Bhavani Prasad Dornala</p>
                </div>
              </div>
            </Reveal>
          </div>
          <div className="md:col-span-7">
            <Reveal delay={150}>
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#C6A35B]">Leadership</p>
              <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-[#144726] tracking-tight">
                A commercial real estate specialist focused on owner outcomes.
              </h2>
              <p className="mt-5 text-slate-600 leading-relaxed">
                Bhavani Prasad Dornala leads Cespedis with deep expertise in corporate leasing, retail leasing, landlord representation, and property management. His approach is to help commercial property owners unlock asset value through strategic leasing and professional management — with measurable outcomes at every stage.
              </p>
              <p className="mt-4 text-slate-600 leading-relaxed">
                Over the years, he has advised landlords, developers, and investors across Hyderabad on tenant acquisition, portfolio strategy, and operational excellence. Cespedis was founded on a single conviction: that disciplined leasing and management can meaningfully shift the long-term performance of any commercial asset.
              </p>
              <div className="mt-7 flex flex-wrap items-center gap-3">
                <Link to="/contact" className="inline-flex items-center gap-2 rounded-lg bg-[#144726] px-5 py-3 text-sm font-semibold text-white hover:bg-[#0E3520] transition-colors" data-testid="founder-cta-contact">
                  Connect with the team <ArrowRight className="h-4 w-4" />
                </Link>
                <a href={`tel:${SITE.phoneTel}`} className="inline-flex items-center gap-2 rounded-lg border border-[#C6A35B] px-5 py-3 text-sm font-semibold text-[#144726] hover:bg-[#C6A35B]/10 transition-colors"><Phone className="h-4 w-4" /> {SITE.phone}</a>
                <a href={`mailto:${SITE.email}`} className="inline-flex items-center gap-2 text-sm font-semibold text-slate-700 hover:text-[#144726] link-gold"><Mail className="h-4 w-4" /> {SITE.email}</a>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
